import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Currency } from '../api';
import { useAppState } from '../state/appstate/appstate';
import { LoadingSpinner } from './loading-spinner/loading-spinner';
import { useUiState } from '../state/ui-state/ui-state';

export const PredefinedRoute: React.FunctionComponent<{
  component: React.FunctionComponent<any>;
}> = ({ component: Component, ...rest }) => {
  const params = new URLSearchParams(window.location.search);
  const configurationId =
    params.get('c') === null ? undefined : params.get('c')!;
  const styleId = params.get('s') === null ? undefined : params.get('s')!;
  const productId = params.get('p') === null ? undefined : params.get('p')!;
  const currency = params.get('currency') || params.get('m') || Currency.USD;
  const {
    loadConfiguration,
    setStyleById,
    setProductById,
    setCurrency,
    reset,
  } = useAppState((state) => ({
    loadConfiguration: state.loadConfiguration,
    setStyleById: state.setStyleById,
    setProductById: state.setProductById,
    setCurrency: state.setCurrency,
    reset: state.reset,
  }));
  const { setIsFromWebsite } = useUiState();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (configurationId && productId) {
        reset();
        setCurrency(currency as Currency);
        await loadConfiguration(configurationId, productId, currency as Currency);
        setLoaded(true);
      } else if (productId && styleId) {
        reset();
        setCurrency(currency as Currency);
        setIsFromWebsite(true);
        await setProductById(productId);
        await setStyleById(styleId);
        setLoaded(true);
      } else if (productId) {
        setCurrency(currency as Currency);
        await setProductById(productId);
        setLoaded(true);
      } else {
        setCurrency(currency as Currency);
        setLoaded(true);
      }
    };
    if (!loaded) {
      load();
    }
    // have to be called only once, so [] as deps
  }, []);

  return loaded ? (
    <Route
      {...rest}
      render={(props) =>
        (configurationId && productId) || (productId && styleId)
          ? (<Redirect to="/build" />)
          : productId
            ? (<Redirect to="/styles" />)
            : ( <Component {...props} />
        )
      }
    />
  ) : (
    <div className="divLoader">
      <LoadingSpinner />
    </div>
  );
};
